import CryptPage from "./CryptPage";
export default CryptPage;